/**
 * Judge.me Reviews Collapse/Expand Functionality
 * Shows limited reviews by default with "See more" button
 */
(() => {
  const WIDGET_SEL = ".jdgm-all-reviews-widget";
  const ACTIVE_PANEL_SEL = ".jdgm-subtab__content.jdgm--active, .jdgm-all-reviews-widget";
  const BTN_WRAP_CLASS = "jdgm-see-more-wrap";
  const BTN_CLASS = "jdgm-see-more-btn";
  const COLLAPSED_CLASS = "jdgm-collapsed";

  // Set how many cards you want visible when collapsed
  const LIMIT = 3;

  function getActiveContainer(widget) {
    return widget.querySelector(ACTIVE_PANEL_SEL) || widget;
  }

  function getCards(container) {
    return Array.from(container.querySelectorAll(".jdgm-rev"));
  }

  function ensureToggle(container) {
    let wrap = container.querySelector(`.${BTN_WRAP_CLASS}`);
    if (!wrap) {
      wrap = document.createElement("div");
      wrap.className = BTN_WRAP_CLASS;

      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = BTN_CLASS;
      btn.textContent = "See more reviews";

      btn.addEventListener("click", () => {
        const collapsed = container.classList.toggle(COLLAPSED_CLASS);
        btn.textContent = collapsed ? "See more reviews" : "See fewer reviews";
      });

      wrap.appendChild(btn);
      container.appendChild(wrap);
    }
    return wrap.querySelector(`.${BTN_CLASS}`);
  }

  function applyCollapse(widget) {
    const container = getActiveContainer(widget);
    const cards = getCards(container);
    const btn = ensureToggle(container);

    // No need for collapse if <= LIMIT
    if (cards.length <= LIMIT) {
      container.classList.remove(COLLAPSED_CLASS);
      btn.hidden = true;
      return;
    }

    btn.hidden = false;

    // Default to collapsed on first paint
    if (!container.dataset.jdgmCollapseInit) {
      container.classList.add(COLLAPSED_CLASS);
      container.dataset.jdgmCollapseInit = "1";
      btn.textContent = "See more reviews";
    }
  }

  function init() {
    const widget = document.querySelector(WIDGET_SEL);
    if (!widget) return;

    // Initial apply
    applyCollapse(widget);

    // Re-apply whenever Judge.me re-renders (load more, tab switch, filters, etc.)
    const mo = new MutationObserver(() => applyCollapse(widget));
    mo.observe(widget, { childList: true, subtree: true });
  }

  // Judge.me often renders after DOMContentLoaded; run both now and after load.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  window.addEventListener("load", init);
})();
